import {Component, OnInit, Input, ViewChild} from '@angular/core';
import { MobileLinksDTO} from '@signature-it/ngx-generic/models';
import { AuthService, ShareDataService } from '@signature-it/ngx-generic/services';
import { IUser } from '@signature-it/ngx-generic/interfaces';

@Component({
    selector: 'user-login',
    templateUrl: './user-login.component.html',
    styleUrls: ['./user-login.component.scss'],
    standalone: false
})
export class UserLoginComponentGeneric implements OnInit {
    @Input()  account : MobileLinksDTO[];
    static userAuthenticated: boolean;
    isUserAuth: boolean;
    usersData: IUser;
    @ViewChild('collapseHeaderMenu', {static: true}) collapseHeaderMenu;
    constructor(protected authService: AuthService,
                public shareDataService: ShareDataService) {
    }

    ngOnInit() {
        const self = this;
        // user's details
        this.shareDataService.loginData$.subscribe(
            (isLoggedIn: boolean) => {
                this.authService.currentUsersData$.subscribe((user: IUser) => {
                    if(user) {
                        self.usersData = user;
                        UserLoginComponentGeneric.userAuthenticated = isLoggedIn;
                        self.isUserAuth = UserLoginComponentGeneric.userAuthenticated;
                    }
                });
            }
        );
    }

    get isUserAuthenticated() {
        return UserLoginComponentGeneric.userAuthenticated;
    }

    sidebarToggle(event, elem: HTMLElement) {
        elem.classList.remove('show');
    }

}
